import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { Checkbox } from '../../../../../CommonComponents/OPL/Checkbox/Checkbox';

export const Premium = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Box display="flex" flexDirection="column">
      <Controller
        control={formBag.control}
        name="Premium"
        render={({ field: { onChange, ...field } }) => (
          <InputNumberMask
            {...field}
            label="Premium"
            decimalScale={2}
            allowNegative={false}
            leftIcon="far fa-dollar-sign"
            innerText="/year"
            maxLength={14}
            onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
          />
        )}
      />

      <Checkbox {...formBag.register('IsPreTaxPremium')} mt="4">
        Pre-tax Dollars
      </Checkbox>
    </Box>
  );
};
